import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Heading } from '@tg/core/components';

const NotFound = () => {
  const { t } = useTranslation('errors');

  return (
    <>
      <Container>
        <div className='text-center'>
          <Heading element='h1' level='h2'>
            {t('404.heading')}
          </Heading>
          <p>{t('404.description')}</p>
        </div>
      </Container>
    </>
  );
};

export default NotFound;
